<template>
  <div class="box_loading_baidi_wraper" v-if="isShow">
    <!-- 常规的加载loading -->
    <div v-if="type === 1" class="loading_baidi">
      <img src="~assets/img/loading/loading_baidi.gif" alt />
      <div class="loading_baidi_text">{{ msg }}</div>
    </div>
    <!-- 长时间加载loading -->
    <div v-if="type === 2" class="loading_baidi_2">
      <img src="~assets/img/loading/loading_baidi.gif" alt />
      <div class="loading_baidi_text_2">{{ msg }}</div>
    </div>

		<!-- 长时间加载loading-包装一个对象传进来，可以显示动态文字，使用搜索 动态文字 loading -->
    <div v-if="type === 4" class="loading_baidi_2">
      <img src="~assets/img/loading/loading_baidi.gif" alt />
      <div class="loading_baidi_text_2">{{ msg.text }}</div>
    </div>

    <!-- 带取消按钮,长时间加载的loading----->
    <!-- <div v-if="type === 3" class="loading_baidi_2">
      <img src="~assets/img/loading/loading_baidi.gif" alt />
      <div class="loading_baidi_text_2">{{ msg }}</div>
      <div class="tips_toast6_btn" @click="clickCancelBtnHandle">确定并返回</div>
    </div> -->

    <!-- 注意不可以用 3 了,3 在手机端已经被占用  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "加载中...",
      isShow: false
    };
  },
  methods: {
    // clickCancelBtnHandle() {
    //   this.isShow = false;
    // }
  }
};
</script>

<style>
.box_loading_baidi_wraper {
  position: fixed;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  z-index: 100;

}



.loading_baidi {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  border-radius: 5px;


  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading_baidi img {
  display: inline-block;
  height: 40px;
  width: 40px;
}

.loading_baidi_text {
  font-size: 14px;
  display: inline-block;
}


/* 长时间加载的loading */
.loading_baidi_2 {
  width: 220px;
  height: 130px;
  background-color: #f5f5f5;
  border-radius: 5px;
  padding: 25px;

  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading_baidi_2 img {
  display: inline-block;
  height: 40px;
  width: 40px;
  margin-bottom: 10px;
}

.loading_baidi_text_2 {
  font-size: 14px;
  color: #282828;
  display: inline-block;
  text-align: center;
}



.tips_toast6_btn {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: var(--primary-color);

  margin: 26px 50px;
  border-radius: 5px;
  color: #ffffff;
  font-size: 16px;
}

.tips_toast6_btn:active {
  background: #a0a3a5;
  /* border: 0px solid #a0a3a5; */
}
</style>
